import type {
  SummaryListActionConfig,
  SummaryListField,
} from "../services/types/ComponentTypes";
import { ActionType, ComponentType } from "../services/types/ComponentTypes";

export const VOID_CONFIRM_MESSAGE =
  "Are you sure you want to void this transaction? This action cannot be undone.";

export const VOID_STATUS_SQL =
  "CASE WHEN COALESCE({alias}.is_void, 0) = 1 THEN 'Void' ELSE '' END AS status";

export const VOID_STATUS_FIELD: SummaryListField = {
  IncludeLabel: true,
  Label: "Status",
  BindValue: "txt_status",
  Json_Attribute: "status",
  componentType: ComponentType.TEXT_FIELD,
  showInSummary: true,
};

export function buildVoidSummaryAction(
  module: string,
  options?: { transactionNoField?: string }
): SummaryListActionConfig {
  return {
    ActionType: ActionType.VOID,
    permissionKey: "Void",
    confirmMessage: VOID_CONFIRM_MESSAGE,
    requireVoidReason: true,
    hiddenWhenVoid: true,
    visibleWhenNotDraft: true,
    voidReasonLabel: "Void Reason",
    tooltip: "Void",
    Action: {
      Module: module,
      ...(options?.transactionNoField
        ? { TransactionNoField: options.transactionNoField }
        : {}),
    },
  };
}

export function appendVoidStatusToQuery(
  query: string,
  tableAlias: string
): string {
  const statusExpr = VOID_STATUS_SQL.replace("{alias}", tableAlias);
  const upper = query.toUpperCase();
  if (upper.includes(" AS STATUS") || upper.includes(" AS STATUS,")) {
    return query;
  }
  const selectIdx = upper.indexOf("SELECT ");
  if (selectIdx < 0) {
    return query;
  }
  const afterSelect = query.slice(selectIdx + 7);
  return `${query.slice(0, selectIdx + 7)}${statusExpr}, ${afterSelect}`;
}

export function hiddenWhenVoidActionTypes(): string[] {
  return ["edit", "delete", "approve", "submit"];
}
